import { render, staticRenderFns } from "./ShowerRoomCount.vue?vue&type=template&id=20058218&"
import script from "./ShowerRoomCount.vue?vue&type=script&lang=ts&"
export * from "./ShowerRoomCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports